import { render, staticRenderFns } from "./default-roster-subject.vue?vue&type=template&id=855a08a0&scoped=true&"
import script from "./default-roster-subject.ts?vue&type=script&lang=ts&"
export * from "./default-roster-subject.ts?vue&type=script&lang=ts&"
import style0 from "./default-roster-subject.scss?vue&type=style&index=0&id=855a08a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855a08a0",
  null
  
)

export default component.exports